// eslint-disable-next-line import/prefer-default-export
export const getBase64 = (file: Blob) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

export const formatXLSName = (xlsName: string) => {
  // Ported from old BO;
  const fileName = xlsName.split('/').pop() as string;
  const fileExtension = fileName.split('.').pop() as string;
  //36 from hash + 2 from backend added
  const hashLenght = 38;
  // need to be decoded first
  const decodedName = decodeURIComponent(fileName.replace(/\+/g, ' '));
  const formattedName = decodedName.replace(
    decodedName.substring(
      decodedName.length - (hashLenght + fileExtension.length),
      decodedName.length - fileExtension.length
    ),
    '.'
  );
  return formattedName;
};
